import React, { useEffect } from 'react';
import styled from 'styled-components';
import { Form, Col } from 'antd';

import { colors } from 'helpers/ColorHelper';
import { getTranslatedString } from 'helpers/i18n';
import paysafeConfig from 'config/services/paysafe';

var API_KEY = paysafeConfig.apiKey;
var OPTIONS = {
  environment: paysafeConfig.env,
  fields: {
    cardNumber: {
      selector: '#card-number',
      placeholder: '',
    },
    expiryDate: {
      selector: '#expiration-date',
      placeholder: 'MM/YY',
    },
    cvv: {
      selector: '#cvv',
      placeholder: '',
    },
  },
  style: {
    input: {
      'font-weight': 'normal',
      'font-family': "'Open Sans' sans-serif",
      'font-size': '14px',
      color: '#595959',
    },
  },
};

const style = {
  base: {
    borderRadius: '2px',
    height: '36px',
    marginBottom: '0.5rem',
    padding: '4px 11px',
    color: 'rgba(0, 0, 0, 0.85)',
    fontSize: '14px',
    lineHeight: '1.5715',
    backgroundColor: '#fff',
    backgroundImage: 'none',
    border: '1px solid #d9d9d9',
    borderRadius: '2px',
    transition: 'all 0.3s',
    display: 'inline-flex',
  },
};

const StyledCol = styled(Col)`
  margin-top: 12px;
`;

const StyledErrorP = styled.p`
  color: ${colors.YUHU_RED};
`;

export const PaysafeFields = ({
  setPaysafeInstance,
  cardNumberError,
  cvvError,
  expiryDateError,
  setCardNumberError,
  setCvvError,
  setExpiryDateError,
}) => {
  useEffect(() => {
    window.paysafe.fields.setup(API_KEY, OPTIONS, (paysafeInstance, error) => {
      if (error) {
        window.Rollbar.error('Setup error: ' + error.code + ' ' + error.detailedMessage);
      } else {
        setPaysafeInstance(paysafeInstance);

        paysafeInstance
          .fields('cvv cardNumber expiryDate')
          .fieldValueChange(function (instance, event) {
            if (event.target.fieldName === 'CardNumber') {
              if (!instance.fields.cardNumber.isValid()) {
                setCardNumberError(getTranslatedString('tenantPortal.paysafe.invalidCardNumber'));
              } else {
                setCardNumberError(null);
              }
            } else if (event.target.fieldName === 'Cvv') {
              if (!instance.fields.cvv.isValid()) {
                setCvvError(getTranslatedString('tenantPortal.paysafe.invalidCVVNumber'));
              } else {
                setCvvError(null);
              }
            } else if (event.target.fieldName === 'ExpiryDate') {
              setExpiryDateError();
              if (!instance.fields.expiryDate.isValid()) {
                setExpiryDateError(getTranslatedString('tenantPortal.paysafe.invalidDate'));
              } else {
                setExpiryDateError(null);
              }
            }
          });

        paysafeInstance.fields('cvv cardNumber expiryDate').valid((instance, event) => {
          if (event.target.fieldName === 'CardNumber') {
            setCardNumberError();
            setCardNumberError(null);
          } else if (event.target.fieldName === 'Cvv') {
            setCvvError();
            setCvvError(null);
          } else if (event.target.fieldName === 'ExpiryDate') {
            setExpiryDateError(null);
          }
        });
        paysafeInstance.fields('cvv cardNumber expiryDate').invalid((instance, event) => {
          if (event.target.fieldName === 'CardNumber') {
            setCardNumberError(getTranslatedString('tenantPortal.paysafe.invalidCardNumber'));
            setCardNumberError();
          } else if (event.target.fieldName === 'Cvv') {
            setCvvError();
            setCvvError(getTranslatedString('tenantPortal.paysafe.invalidCVVNumber'));
          } else if (event.target.fieldName === 'ExpiryDate') {
            setExpiryDateError();
            setExpiryDateError(getTranslatedString('tenantPortal.paysafe.invalidDate'));
          }
        });
      }
    });
  }, [setPaysafeInstance, setCardNumberError, setCvvError, setExpiryDateError]);

  return (
    <>
      <StyledCol md={12} sm={24}>
        <Form.Item label="Card number" required>
          <div id="card-number" style={style.base} />
          {cardNumberError && <StyledErrorP>{cardNumberError}</StyledErrorP>}
        </Form.Item>
      </StyledCol>
      <StyledCol md={12} sm={24}>
        <Form.Item label="CVV" required>
          <div id="cvv" style={style.base} />
          {cvvError && <StyledErrorP>{cvvError}</StyledErrorP>}
        </Form.Item>
      </StyledCol>
      <StyledCol md={12} sm={24}>
        <Form.Item label="Expiry date" required>
          <div id="expiration-date" style={style.base} />
          {expiryDateError && <StyledErrorP>{expiryDateError}</StyledErrorP>}
        </Form.Item>
      </StyledCol>
    </>
  );
};
